<template>
  <div>
      <v-layout
        align-start
        justify-start
        v-if="component.controlName === 'titleBar'"
        class="titleBar"
      >
        <v-flex lg12>
          <div class="stepHeader">
            <v-layout
              :class="[component.customClass, 'form-control']"
            >
              <v-flex lg8 
                v-if="component.reviewName"
              >
                <span> {{ component.reviewName }}</span>
              </v-flex>
              <v-flex lg8 v-else>
                <span> {{ component.displayName }}</span>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
      <div class="form-item-ctr">
        <div
          class="form-item-review"
          v-if="component.controlName !== 'titleBar' && hasChildren"
          :class="['lg12']"
        >
          <v-flex lg3 class="col-name">
            <span v-if="component.refId === 'saml'" :autoid="component.autoid + '-review'"> SAML </span>

            <span v-else :autoid="component.autoid + '-review'"> {{ component.displayName }} </span>
          </v-flex>
          <v-flex
            lg9
            class="col-value multiple-value contact"
            v-if="
              component.controlName === 'formGroup' &&
                component.formData.length !== 0
            "
          >
            <span
              v-for="(colvalue, index) in component.formData"
              :key="index"
              v-if="
                colvalue.defaultValue !== '' && 
                  colvalue.show !== false && 
                  colvalue.controlName !== 'resetButton' && 
                  colvalue.controlName !== 'inputHidden' && 
                  colvalue.controlName !== 'groupTitle'"
              :class="[(colvalue.show === false) ? 'd-none' : 'contact-field']"
            >
              <span v-if="colvalue.defaultValue !== ''">
                {{ colvalue.displayName }} :
                {{ colvalue.defaultValue }}
              </span>
            </span>
          </v-flex>
          <v-flex
            lg4
            class="col-value multiple-value merged-prods"
            v-else-if="
                component.controlName === 'reviewGroup' && component.mergeProducts.length
            "
          >
            <div
              class="d-flex"
              v-for="(colvalue, index) in component.mergeProducts"
              :key="index"
              >
                <span v-if="colvalue.defaultValue"> 
                  {{ colvalue.displayName }}  
                </span>
              </div
            >
          </v-flex>
          <v-flex
            lg4
            class="col-value multiple-value api-prods"
            v-else-if="
              component.controlName === 'productGroup' &&
                component.reviewRef === 'selectedApiProds' &&
                component.defaultValue === true &&
                component.formData.length !== 0
            "
          >
            <div
              class="d-flex"
              v-for="(colvalue, index) in component.formData"
              :key="index"
              v-if="colvalue.show != false"
                >{{ colvalue.displayName }} <span class="ml-1 mb-0" v-if="colvalue.defaultValue"> enabled </span> <span class="ml-1 mb-0" v-else> disabled </span> 
                <div class="break" v-if="colvalue.formData"></div>
                
                <div class="d-flex child-form" v-if="colvalue.formData && colvalue.defaultValue == true">
                    <span
                        class=""
                        v-for="(innerChild, index) in colvalue.formData"
                        :key="index"
                            >{{ innerChild.displayName }} : {{ innerChild.defaultValue }} 
                    </span>
                </div>
            </div>
          </v-flex>
          <v-flex
            lg4
            class="col-value multiple-value finapps"
            v-else-if="
              component.controlName === 'productGroup' &&
                component.defaultValue === true &&
                component.formData.length !== 0
            "
          >
            <div
              v-for="(colvalue, index) in component.formData"
              :key="index"
              v-if="colvalue.defaultValue !== false" 
                > 
                <span v-if="colvalue.defaultValue"> {{ colvalue.displayName }} </span> 
                </div
            >
          </v-flex>
          <v-flex
            lg4
            class="col-value"
            v-else-if="component.controlName == 'radioGroup'"
          >
            <span
              v-for="(colvalue, index) in component.options"
              :key="index"
            >
              <span v-if="component.defaultValue == colvalue.value">{{
                colvalue.displayName
              }}</span>
            </span>
          </v-flex>
          <v-flex
            lg4
            class="col-value multiple-value checkbox"
            v-else-if="
              component.controlName === 'checkboxGroup' &&
                component.dataType == 'array'
            "
          >
            <div
              class="login-values"
              v-for="(colvalue, index) in component.defaultValue"
              :key="index"
            >
              <div
                v-for="(optvalue, index) in component.options"
                :key="index"
                :class="{'d-none' : (optvalue.value != colvalue) }"
              >
                <span v-if="optvalue.value == colvalue">
                  {{ optvalue.displayName }}
                </span>
              </div>
            </div>
          </v-flex>
          <v-flex
            lg4
            class="col-value multiple-value array"
            v-else-if="component.dataType == 'array' &&
              component.defaultValue.length !== 0 &&
              component.controlName != 'reviewGroup'"
          >
            <span
              v-for="(colvalue, index) in component.defaultValue"
              :key="index"
              >{{ colvalue }}</span
            >
          </v-flex>
          <v-flex
            lg4
            class="col-value enabled"
            v-else-if="
              component.defaultValue && 
              component.controlName === 'productGroup'"
          >
            <span> Enabled </span>
          </v-flex>
          <v-flex
            lg4
            class="col-value disabled"
            v-else-if="!component.defaultValue && 
              component.controlName === 'productGroup'"
          >
            <span> Disabled </span>
          </v-flex>
          <v-flex
            lg4
            class="col-value singleValue"
            v-else-if="component.defaultValue && 
              component.defaultValue.length !== 0 &&
              component.controlName != 'reviewGroup'"
          >
            <span>{{ component.defaultValue }}</span>
          </v-flex>
          <v-flex lg4 class="col-value na" v-else>
            <span>N/A</span>
          </v-flex>
          <v-flex></v-flex>
          <v-flex></v-flex>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      component: this.dataProps
    }
  },
  props: {
    dataProps: Object
  },
  created() {},
  methods: {},
  computed: {
    hasChildren() {
      var showParent = true
      if (this.dataProps.formData && this.dataProps.formData.length) {
        if(this.dataProps.sdpValue == 'Aggregation' || this.dataProps.sdpValue == 'Verification') {
            showParent = this.dataProps.formData.some(childComp => {
                return childComp.show
            })
        }
      }
       return showParent
    }
  }
}
</script>

<style lang="scss">
.reviewCtr {
  .stepHeader {
    margin-bottom: 12px;
  }

  .form-item-review {
    display: flex;
    margin-bottom: 22px;
    font-size: 15px;
  }

  .col-name {
    line-height: 18px;
    color: #888888;
  }

  .col-value {
    line-height: 18px;
    color: #383838;

    span {
      display: block;
    }

    &.multiple-value {
      > span, &.checkbox span, 
      &.finapps span,&.merged-prods span{
        margin-bottom: 22px;
        word-break: break-all;
      }
    }
    &.multiple-value {
      > span:last-child, &.checkbox .login-values:last-child div > span, 
      &.finapps div:last-child span, &.merged-prods .d-flex:last-child span,
      &.contact .contact-field:last-child span{
        margin-bottom: 0;
      }
    }
    &.multiple-value.api-prods {
        & > div.d-flex:not(:last-child) {
            margin-bottom: 22px;
        }
        div.d-flex:nth-last-child(1){
            flex-wrap: wrap;
        }
        .break{
            flex-basis: 100%;
        }
        .child-form{
            margin-top: 22px;
            > span:not(:first-child) {
                margin-top: 22px;
            }
            > span:last-child {
                margin-bottom: 0;
            }
        }
    }
  }
}
</style>
